import {
    getPublicContentSource,
} from "@logscord/public-site-config";
import MarkdownModules from "virtual:logscord-public-content";


//////////////////////////////////////////////////
//  PUBLIC CONTENT REGISTRY
//////////////////////////////////////////////////


export function getClientPublicContent(contentKey: string, locale: string) {
    const source = getPublicContentSource(contentKey, locale);

    if (!source)
        return "";

    return MarkdownModules[source.sourcePath] ?? "";
}
